<template>
  <tr @click="toggleSelf" style="cursor: pointer">
    <td style="padding-left: 60px">
        {{ data.name }}
      <span class="glyphicon is-aligned-right" :class="data.is_open ? ' glyphicon-collapse-up' : ' glyphicon-collapse-down'"></span>
    </td>
    <td>{{ usNum(data.app_goal)}}</td>
    <td>{{ usNum(data.apps)}}</td>
    <td>{{ money(data.budget)}}</td>
    <td>{{ money(data.spend)}}</td>
    <td>{{ percent(data.percentage) }}</td>
    <td>{{ money(data.cpl) }}</td>
    <td>{{ money(data.billable )}}</td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
</template>

<script>
export default {
  props: [
    'data'
  ],
  data() {
    return {
    };
  },
  methods: {
    toggleSelf() {
      this.data.is_open = !this.data.is_open;
    }
  }
}
</script>

<style>
</style>
